import { useStaticQuery, graphql } from "gatsby"

const useExhibitionPhotos = () => {
  const { allFile } = useStaticQuery(graphql`
  query {
    allFile(
      filter: { relativeDirectory: { eq: "exhibition" } }
      sort: { fields: [relativePath], order: DESC }
    ) {
      nodes {
        childImageSharp {
          id
          fluid {
            ...GatsbyImageSharpFluid
          }
        }
      }
    }
  }
  `)

  return allFile.nodes
}

export default useExhibitionPhotos
